import { render, staticRenderFns } from "./Spouse.vue?vue&type=template&id=63389ea1&scoped=true"
import script from "./Spouse.vue?vue&type=script&lang=js"
export * from "./Spouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63389ea1",
  null
  
)

export default component.exports